import { Component, OnInit } from '@angular/core';
import { MapOverviewStats, MapOverviewStatsComponent } from '../map-overview-stats/map-overview-stats.component';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import * as _ from 'underscore';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { GAM_PRODUCT_SEPERATED_Rs } from '../../../analytics/constants/analytics.constants';

@Component({
	selector: 'app-r6-map-overview-stats',
	templateUrl: './r6-map-overview-stats.component.html',
	styleUrls: ['./r6-map-overview-stats.component.css']
})
export class R6MapOverviewStatsComponent extends MapOverviewStatsComponent implements OnInit {
	private productOrder = {
		Display: 1,
		GeoFence: 2,
		'Pre Roll': 3,
		GeoVideo: 4,
		Sem: 5,
		'Connected TV': 6,
		'Streaming Audio': 7,
		nexstar: 8,
		Social: 9,
		Email: 10
	};
	public isR6: boolean;
	public overviewReport: boolean = false;
	public OverviewReportPermission: object = { permission: { flags: ['hasOverviewPrintableAccess'] } };
	public gamMapPermission: object = { permission: { flags: ['hasGamMapAccess'] } };
	public hasGamMapAccess: boolean = false;
	public isGamSeperated_R: boolean = false;

	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService, analyticsDataModel);
	}

	ngOnInit() {
		// Moving requestData() to the super class constructor to ensure it's called only when INITIATE_MAP_STATS is ready.
		// this.requestData();
		this.youtubeViewsPermission = this.analyticsDataModel.checkComponentForPermission(this.youtubeViewsPermissionCheck);
		this.hasGamMapAccess = this.analyticsDataModel.checkComponentForPermission(this.gamMapPermission);
		this.isGamSeperated_R = GAM_PRODUCT_SEPERATED_Rs.includes(this.analyticsDataModel.config.directoryName);
		this.overviewReport = this.isR6 = this.analyticsDataModel.config.version === 'R6' ? true : false;
		this.overviewReport = this.overviewReport
			? this.analyticsDataModel.checkComponentForPermission(this.OverviewReportPermission)
			: this.overviewReport;
	}

	toggleProductSelection(onlyUpdate?) {
		const combinedOverviewStats = _.union(this.overviewStats, this.overviewYoutubeStats);
		const enabledProducts = _.where(combinedOverviewStats, { isDisabled: false });
		const excludedProducts = _.where(enabledProducts, { isExclude: false });
		const selectedProducts = _.where(excludedProducts, { productSelected: true });
		const removedProducts = _.where(excludedProducts, { productSelected: false });
		if (onlyUpdate) {
			EmitterService.get(EVENT_EMITTERS.UPDATE_PRODUCT_MAP_LEGEND).emit({
				selected: selectedProducts,
				removed: removedProducts
			});
		} else {
			EmitterService.get(EVENT_EMITTERS.TOGGLE_PRODUCT_MAP_LEGEND).emit({
				selected: selectedProducts,
				removed: removedProducts
			});
		}
	}

	productSelection(overviewStat) {
		if (overviewStat) {
			overviewStat.productSelected = !overviewStat.productSelected;
		}
		const combinedOverviewStats = _.union(this.overviewStats, this.overviewYoutubeStats);
		const enabledProducts = _.where(combinedOverviewStats, { isDisabled: false });
		const excludedProducts = _.where(enabledProducts, { isExclude: false });
		const selectedProducts = _.where(excludedProducts, { productSelected: true });
		const removedProducts = _.where(excludedProducts, { productSelected: false });
		setTimeout(() => {
			EmitterService.get(EVENT_EMITTERS.TOGGLE_PRODUCT_MAP_LEGEND).emit({
				selected: selectedProducts,
				removed: removedProducts,
				showLiftDetails: this.showLiftDetails(selectedProducts).length > 0
			});
		});
	}

	mapResponseDataToInterface(responseData: any) {
		let count = 0;
		let allProducts = [];

		//sorting data by product order
		responseData.sort((p1: any, p2: any) => {
			return this.productOrder[p1.product_name] > this.productOrder[p2.product_name]
				? 1
				: this.productOrder[p1.product_name] < this.productOrder[p2.product_name]
				? -1
				: 0;
		});

		for (const responseObj of responseData) {
			if (count !== responseData.length - 1) {
				const overviewStatsObj: MapOverviewStats = <MapOverviewStats>{};
				overviewStatsObj.productId = parseInt(responseObj.product_id);
				overviewStatsObj.productName =
					responseObj.product_name === 'Connected TV'
						? 'CTV/OTT'
						: responseObj.product_name.toLowerCase() === 'gam' && this.isR6
						? 'Nexstar'
						: responseObj.product_name;
				overviewStatsObj.productSelected = true;
				overviewStatsObj.impressions = responseObj.impressions != null ? parseInt(responseObj.impressions) : 0;
				overviewStatsObj.clicks = responseObj.clicks != null ? parseInt(responseObj.clicks) : 0;
				overviewStatsObj.hasClicks = !(
					overviewStatsObj.productName === 'CTV/OTT' || overviewStatsObj.productName === 'Streaming Audio'
				);
				overviewStatsObj.isEmail = overviewStatsObj.productName === 'Email';
				overviewStatsObj.isSocial = overviewStatsObj.productName === 'Social';
				overviewStatsObj.ctr = responseObj.ctr != null ? parseFloat(responseObj.ctr) : 0;
				overviewStatsObj.completions = responseObj.completions != null ? parseInt(responseObj.completions) : 0;
				overviewStatsObj.completions_rate =
					responseObj.completions_rate != null ? parseFloat(responseObj.completions_rate) : 0;
				overviewStatsObj.hasCtr = overviewStatsObj.hasClicks;
				overviewStatsObj.isExclude = count === responseData.length - 1;
				// Earlier, we were checking "overviewStatsObj.clicks === 0 && overviewStatsObj.impressions === 0;" for enabling the map legend.
				// Updating to get the status of each product from "MapComponentService," which is more reliable.
				const productData = this.isR6
					? this.mapObj?.find((item) => {
							if (item.productName.toLowerCase() === 'gam') {
								item.productName = 'Nexstar';
							} else if (item.productName === 'Connected TV') {
								item.productName = 'CTV/OTT';
							}
							return item.productName === overviewStatsObj.productName;
					  })
					: null;

				if (productData && !productData.isDisabled) {
					productData.isDisabled = overviewStatsObj.clicks === 0 && overviewStatsObj.impressions === 0;
				}

				overviewStatsObj.isDisabled = productData ? productData.isDisabled : true;
				overviewStatsObj.productKey = this.getProductKeyByProductName(overviewStatsObj.productName);
				count++;
				if (!allProducts.includes(overviewStatsObj.productKey)) {
					let tempPermissions = [];
					tempPermissions = this.analyticsDataModel.setupData.permissions;
					let gam_seperated = GAM_PRODUCT_SEPERATED_Rs.includes(this.analyticsDataModel.config.directoryName);
					if (
						overviewStatsObj.productKey !== 'gam' ||
						(overviewStatsObj.productKey == 'gam' && gam_seperated && tempPermissions.includes('hasGAM'))
					) {
						allProducts.push(overviewStatsObj.productKey);
						this.overviewStats.push(overviewStatsObj);
					}
				}
				if (responseObj.product_name == 'Pre Roll' && this.isR6) {
					const overviewYoutubeStatsObj: MapOverviewStats = <MapOverviewStats>{};
					overviewYoutubeStatsObj.productId = overviewStatsObj.productId;
					overviewYoutubeStatsObj.youtubeViews =
						responseObj.youtube_verified_imprs != null ? responseObj.youtube_verified_imprs : 0;
					overviewYoutubeStatsObj.productName = 'YouTube';
					overviewYoutubeStatsObj.isDisabled = true;
					if (overviewYoutubeStatsObj.youtubeViews > 0) {
						overviewYoutubeStatsObj.productId = 0;
						overviewYoutubeStatsObj.productSelected = true;
						overviewYoutubeStatsObj.isExclude = false;
						overviewYoutubeStatsObj.isDisabled = true; //Disabling the YouTube product due to the absence of map data to display.
						overviewYoutubeStatsObj.productKey = this.getProductKeyByProductName(overviewYoutubeStatsObj.productName);
					}
					overviewYoutubeStatsObj.youtubeViewRate =
						overviewYoutubeStatsObj.youtubeViews > 0
							? (responseObj.youtube_verified_imprs / responseObj.youtube_imprs) * 100
							: 0;
					this.overviewYoutubeStats.push(overviewYoutubeStatsObj);
				}
			}
		}
	}
}
